// Modules
import RedemptionWidget from "~components/dashboard/RedemptionWidget"

// Components
import PageContent from "~components/PageContent"
import PageHeader from "~components/PageHeader"

const dashboard = () => {
  return (
    <PageContent>
      <PageHeader title={"Dashboard"} />
      <RedemptionWidget />
    </PageContent>
  )
}

export default dashboard
